import { all } from "redux-saga/effects";
import { nhomCauHoiSaga } from "./nhomCauHoiSaga";
import { cauHoiSaga } from "./cauHoiSaga";

export default function* cauHoiSagaWrapper() {
  yield all([nhomCauHoiSaga(), cauHoiSaga()]);
}
